
import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Save, X, AlertCircle } from "lucide-react";

interface ProfileBioEditorProps {
  isEditing: boolean;
  bioText: string;
  setBioText: (bio: string) => void;
  isValid: boolean;
  MAX_BIO_LENGTH: number;
  handleSave: () => void;
  handleCancel: () => void;
}

export const ProfileBioEditor = ({
  isEditing,
  bioText,
  setBioText,
  isValid,
  MAX_BIO_LENGTH,
  handleSave,
  handleCancel
}: ProfileBioEditorProps) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setBioText(e.target.value);
  };

  if (!isEditing) return null;

  return (
    <div className="space-y-4">
      <div className="relative">
        <Textarea
          value={bioText}
          onChange={handleTextChange}
          className={`min-h-[150px] ${!isValid ? 'border-red-500 focus-visible:ring-red-500' : ''}`}
          placeholder="Tell others about yourself..."
          maxLength={MAX_BIO_LENGTH}
        />
        <div className="flex justify-between text-xs mt-1">
          <span className={bioText.trim().length === 0 ? 'text-red-500' : 'text-gray-500'}>
            {bioText.trim().length === 0 && (
              <span className="flex items-center">
                <AlertCircle className="w-3 h-3 mr-1" />
                Bio cannot be empty
              </span>
            )}
          </span>
          <span className={bioText.length > MAX_BIO_LENGTH * 0.9 ? 'text-amber-500' : 'text-gray-500'}>
            {bioText.length}/{MAX_BIO_LENGTH}
          </span>
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="outline" size="sm" onClick={handleCancel}>
          <X className="w-4 h-4 mr-1" />
          Cancel
        </Button>
        <Button size="sm" onClick={handleSave} disabled={!isValid}>
          <Save className="w-4 h-4 mr-1" />
          Save
        </Button>
      </div>
    </div>
  );
};
